import * as i0 from '@angular/core';
import { Injectable, Component, Inject, ViewEncapsulation, EventEmitter, Directive, Output, HostListener, Input, NgModule, ComponentRef, createComponent } from '@angular/core';
import { Subject, of } from 'rxjs';
import { map, catchError, takeUntil } from 'rxjs/operators';
import { trigger, state, style, transition, animate } from '@angular/animations';
import * as i1 from '@angular/common/http';
import * as i1$3 from '@angular/material/snack-bar';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import * as i1$1 from '@angular/material/icon';
import { MatIconModule } from '@angular/material/icon';
import * as i3 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i1$2 from '@angular/material/dialog';
import { MatDialogModule } from '@angular/material/dialog';
import * as i2 from '@angular/material/button';
import { MatButtonModule } from '@angular/material/button';
import * as i4 from '@angular/material/form-field';
import { MatFormFieldModule } from '@angular/material/form-field';
import * as i5 from '@angular/material/menu';
import { MatMenuModule } from '@angular/material/menu';
import * as i6 from '@angular/material/select';
import { MatSelectModule } from '@angular/material/select';
import * as i7 from '@angular/material/core';
import * as i10 from '@angular/material/progress-spinner';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatInputModule } from '@angular/material/input';
function SnackbarComponent_span_6_span_1_br_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "br");
  }
}
function SnackbarComponent_span_6_span_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span")(1, "span", 10);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, SnackbarComponent_span_6_span_1_br_3_Template, 1, 0, "br", 11);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const messagePart_r1 = ctx.$implicit;
    const last_r2 = ctx.last;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", messagePart_r1, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !last_r2);
  }
}
function SnackbarComponent_span_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 8);
    i0.ɵɵtemplate(1, SnackbarComponent_span_6_span_1_Template, 4, 2, "span", 9);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r2.splittedMessage);
  }
}
function SnackbarComponent_span_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 12);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHTML", ctx_r2.message, i0.ɵɵsanitizeHtml);
  }
}
function ConfirmComponent_div_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 9);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHtml", ctx_r0.confirmMessage, i0.ɵɵsanitizeHtml);
  }
}
function ConfirmComponent_div_7_span_1_br_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "br");
  }
}
function ConfirmComponent_div_7_span_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 12);
    i0.ɵɵtext(1);
    i0.ɵɵtemplate(2, ConfirmComponent_div_7_span_1_br_2_Template, 1, 0, "br", 13);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const messagePart_r2 = ctx.$implicit;
    const last_r3 = ctx.last;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", messagePart_r2, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !last_r3);
  }
}
function ConfirmComponent_div_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵtemplate(1, ConfirmComponent_div_7_span_1_Template, 3, 2, "span", 11);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r0.splittedMessage);
  }
}
function ConfirmComponent_a_9_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 14);
    i0.ɵɵlistener("click", function ConfirmComponent_a_9_Template_a_click_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.dialogRef.close(false));
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.cancelButtonText, "");
  }
}
function ConfirmComponent_button_10_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 15);
    i0.ɵɵlistener("click", function ConfirmComponent_button_10_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.dialogRef.close(false));
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.cancelButtonText, " ");
  }
}
function HeaderComponent_img_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "img", 7);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("src", ctx_r0.headerLogo, i0.ɵɵsanitizeUrl);
  }
}
function HeaderComponent_div_4_mat_spinner_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "mat-spinner");
  }
}
function HeaderComponent_div_4_mat_form_field_2_mat_option_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 10);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const space_r3 = ctx.$implicit;
    i0.ɵɵproperty("value", space_r3.id);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", space_r3.name, " ");
  }
}
function HeaderComponent_div_4_mat_form_field_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-form-field")(1, "mat-select", 8);
    i0.ɵɵlistener("selectionChange", function HeaderComponent_div_4_mat_form_field_2_Template_mat_select_selectionChange_1_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.SwitchSpace());
    });
    i0.ɵɵtwoWayListener("valueChange", function HeaderComponent_div_4_mat_form_field_2_Template_mat_select_valueChange_1_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext(2);
      i0.ɵɵtwoWayBindingSet(ctx_r0.SelectedSpace, $event) || (ctx_r0.SelectedSpace = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵtemplate(2, HeaderComponent_div_4_mat_form_field_2_mat_option_2_Template, 2, 2, "mat-option", 9);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("disableOptionCentering", true);
    i0.ɵɵtwoWayProperty("value", ctx_r0.SelectedSpace);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r0.Spaces);
  }
}
function HeaderComponent_div_4_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "mat-label");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.NoSpaceAssignedString);
  }
}
function HeaderComponent_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵtemplate(1, HeaderComponent_div_4_mat_spinner_1_Template, 1, 0, "mat-spinner", 6)(2, HeaderComponent_div_4_mat_form_field_2_Template, 3, 3, "mat-form-field", 6)(3, HeaderComponent_div_4_div_3_Template, 3, 1, "div", 6);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.isSpaceLoading);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.Spaces && ctx_r0.Spaces.length > 0 && !ctx_r0.isSpaceLoading);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.Spaces && ctx_r0.Spaces.length == 0 && !ctx_r0.isSpaceLoading);
  }
}
function HeaderComponent_mat_spinner_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "mat-spinner");
  }
}
function HeaderComponent_div_7_button_24_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 24);
    i0.ɵɵlistener("click", function HeaderComponent_div_7_button_24_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.openEditProfile());
    });
    i0.ɵɵelementStart(1, "mat-icon", 21);
    i0.ɵɵtext(2, "edit");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r0.EditProfileString);
  }
}
function HeaderComponent_div_7_button_25_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 24);
    i0.ɵɵlistener("click", function HeaderComponent_div_7_button_25_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.revokeRefreshToken());
    });
    i0.ɵɵelementStart(1, "mat-icon", 21);
    i0.ɵɵtext(2, "cancel_presentation");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r0.RevokeTokenString);
  }
}
function HeaderComponent_div_7_button_37_mat_icon_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-icon", 29);
    i0.ɵɵtext(1, "check");
    i0.ɵɵelementEnd();
  }
}
function HeaderComponent_div_7_button_37_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 27);
    i0.ɵɵlistener("click", function HeaderComponent_div_7_button_37_Template_button_click_0_listener() {
      const lang_r8 = i0.ɵɵrestoreView(_r7).$implicit;
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.changeLang(lang_r8.id));
    });
    i0.ɵɵtext(1);
    i0.ɵɵtemplate(2, HeaderComponent_div_7_button_37_mat_icon_2_Template, 2, 0, "mat-icon", 28);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const lang_r8 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("", lang_r8.title, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", lang_r8.id == ctx_r0.languageSelected);
  }
}
function HeaderComponent_div_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "button", 11)(2, "div", 12);
    i0.ɵɵlistener("click", function HeaderComponent_div_7_Template_div_click_2_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.openMenu());
    });
    i0.ɵɵelement(3, "img", 13);
    i0.ɵɵelementStart(4, "span");
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 14)(7, "mat-icon", 15);
    i0.ɵɵtext(8, "arrow_drop_down");
    i0.ɵɵelementEnd()()()();
    i0.ɵɵelementStart(9, "div", 16);
    i0.ɵɵlistener("clickOutside", function HeaderComponent_div_7_Template_div_clickOutside_9_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.hideBothMenu());
    });
    i0.ɵɵelementStart(10, "div", 17)(11, "div", 18);
    i0.ɵɵelement(12, "img", 13);
    i0.ɵɵelementStart(13, "div", 19)(14, "span");
    i0.ɵɵtext(15);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "small");
    i0.ɵɵtext(17);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(18, "div", 20);
    i0.ɵɵlistener("click", function HeaderComponent_div_7_Template_div_click_18_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.openSubMenu());
    });
    i0.ɵɵelementStart(19, "mat-icon", 21);
    i0.ɵɵtext(20, "language");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(21);
    i0.ɵɵelementStart(22, "mat-icon", 22);
    i0.ɵɵtext(23, "keyboard_arrow_right");
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(24, HeaderComponent_div_7_button_24_Template, 4, 1, "button", 23)(25, HeaderComponent_div_7_button_25_Template, 4, 1, "button", 23);
    i0.ɵɵelementStart(26, "button", 24);
    i0.ɵɵlistener("click", function HeaderComponent_div_7_Template_button_click_26_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.logout());
    });
    i0.ɵɵelementStart(27, "mat-icon", 21);
    i0.ɵɵtext(28, "input");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(29);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(30, "div", 25)(31, "div", 20);
    i0.ɵɵlistener("click", function HeaderComponent_div_7_Template_div_click_31_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.hideSubMenu());
    });
    i0.ɵɵelementStart(32, "mat-icon", 21);
    i0.ɵɵtext(33, "keyboard_arrow_left");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(34, "mat-icon", 21);
    i0.ɵɵtext(35, "language");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(36);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(37, HeaderComponent_div_7_button_37_Template, 3, 2, "button", 26);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("disableRipple", true);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("src", !ctx_r0.User.picture ? "assets/images/sample.jpg" : ctx_r0.User.picture, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(!ctx_r0.User.nickName ? ctx_r0.User.fullName : ctx_r0.User.nickName);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("@menuAnimation", ctx_r0.isMainMenuOpened || ctx_r0.isLanguageMenuOpened ? ctx_r0.isMainMenuOpened ? "open" : "other" : "close");
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("src", !ctx_r0.User.picture ? "assets/images/sample.jpg" : ctx_r0.User.picture, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("", ctx_r0.User.fullName, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.User.email);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.LanguageSettingString, " ");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r0.ShowEditProfileLink);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.ShowRevokeTokenLink);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r0.LogoutString);
    i0.ɵɵadvance();
    i0.ɵɵproperty("@menuAnimation", ctx_r0.isMainMenuOpened || ctx_r0.isLanguageMenuOpened ? ctx_r0.isLanguageMenuOpened ? "open" : "other" : "close");
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate(ctx_r0.LanguageSettingString);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r0.Languages);
  }
}
function BannerComponent_div_0_mat_icon_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-icon", 13);
    i0.ɵɵtext(1, " info_outline ");
    i0.ɵɵelementEnd();
  }
}
function BannerComponent_div_0_mat_icon_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-icon", 14);
    i0.ɵɵtext(1, " warning ");
    i0.ɵɵelementEnd();
  }
}
function BannerComponent_div_0_mat_icon_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-icon", 15);
    i0.ɵɵtext(1, " error_outline ");
    i0.ɵɵelementEnd();
  }
}
function BannerComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1)(1, "div", 2)(2, "div", 3)(3, "div", 4);
    i0.ɵɵtemplate(4, BannerComponent_div_0_mat_icon_4_Template, 2, 0, "mat-icon", 5)(5, BannerComponent_div_0_mat_icon_5_Template, 2, 0, "mat-icon", 6)(6, BannerComponent_div_0_mat_icon_6_Template, 2, 0, "mat-icon", 7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 8)(8, "div", 9);
    i0.ɵɵtext(9);
    i0.ɵɵpipe(10, "async");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "div", 10);
    i0.ɵɵtext(12);
    i0.ɵɵpipe(13, "async");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(14, "div", 11)(15, "button", 12);
    i0.ɵɵlistener("click", function BannerComponent_div_0_Template_button_click_15_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.actionClick());
    });
    i0.ɵɵelementStart(16, "span");
    i0.ɵɵtext(17);
    i0.ɵɵpipe(18, "async");
    i0.ɵɵelementEnd()()()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("background", ctx_r1.bannerData.backgroundColor ? ctx_r1.bannerData.backgroundColor : null);
    i0.ɵɵclassProp("error-banner", ctx_r1.bannerData.type === "Error");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngSwitch", ctx_r1.bannerData.type);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "Information");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "Warning");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "Error");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(10, 11, ctx_r1.parseData(ctx_r1.bannerData.informationMessage)), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(13, 13, ctx_r1.parseData(ctx_r1.bannerData.instructionMessage)), " ");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(18, 15, ctx_r1.parseData(ctx_r1.bannerData.actionButtonText)));
  }
}
let UserService = /*#__PURE__*/(() => {
  class UserService {
    constructor(httpClient) {
      this.httpClient = httpClient;
    }
    getUser(serverUlr) {
      return this.httpClient.get(`${serverUlr}management/users/me`).pipe(map(res => {
        return res;
      }), catchError(error => {
        throw error;
      }));
    }
    getUserSpaces(serverUrl) {
      return this.httpClient.get(`${serverUrl}spaces`).pipe(map(res => {
        return res;
      }), catchError(error => {
        throw error;
      }));
    }
    static {
      this.ɵfac = function UserService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || UserService)(i0.ɵɵinject(i1.HttpClient));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: UserService,
        factory: UserService.ɵfac,
        providedIn: "root"
      });
    }
  }
  return UserService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SnackbarComponent = /*#__PURE__*/(() => {
  class SnackbarComponent {
    constructor(snakBarData) {
      this.isShowHTML = false;
      this.snackType = snakBarData.snackType;
      this.snackbar = snakBarData.snackbar;
      this.message = snakBarData.message;
      this.isShowHTML = snakBarData.isShowHTML;
    }
    ngOnInit() {}
    get getIcon() {
      switch (this.snackType) {
        case "success":
          return {
            type: this.snackType,
            icon: "check_circle_outline"
          };
        case "error":
          return {
            type: this.snackType,
            icon: "error_outline"
          };
        case "warn":
          return {
            type: this.snackType,
            icon: "warning"
          };
        case "info":
          return {
            type: this.snackType,
            icon: "info"
          };
      }
    }
    closeSnackbar() {
      this.snackbar.dismiss();
    }
    get splittedMessage() {
      if (this.message) {
        return this.message.split("\n");
      }
    }
    static {
      this.ɵfac = function SnackbarComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SnackbarComponent)(i0.ɵɵdirectiveInject(MAT_SNACK_BAR_DATA));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: SnackbarComponent,
        selectors: [["app-snackbar"]],
        decls: 11,
        vars: 6,
        consts: [[1, "snack-container-message"], [1, "snack-icon"], ["aria-hidden", "false"], [1, "snack-msg"], ["class", "textSpan", 4, "ngIf"], ["class", "htmlSpan", 3, "innerHTML", 4, "ngIf"], [1, "snack-close"], ["aria-hidden", "false", 3, "click"], [1, "textSpan"], [4, "ngFor", "ngForOf"], [1, "messagepart"], [4, "ngIf"], [1, "htmlSpan", 3, "innerHTML"]],
        template: function SnackbarComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div")(1, "div", 0)(2, "div", 1)(3, "mat-icon", 2);
            i0.ɵɵtext(4);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(5, "div", 3);
            i0.ɵɵtemplate(6, SnackbarComponent_span_6_Template, 2, 1, "span", 4)(7, SnackbarComponent_span_7_Template, 1, 1, "span", 5);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(8, "div", 6)(9, "mat-icon", 7);
            i0.ɵɵlistener("click", function SnackbarComponent_Template_mat_icon_click_9_listener() {
              return ctx.closeSnackbar();
            });
            i0.ɵɵtext(10, "close");
            i0.ɵɵelementEnd()()()();
          }
          if (rf & 2) {
            i0.ɵɵclassMapInterpolate1("snack-container box-", ctx.getIcon.type, "");
            i0.ɵɵadvance(4);
            i0.ɵɵtextInterpolate(ctx.getIcon.icon);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", !ctx.isShowHTML);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.isShowHTML);
          }
        },
        dependencies: [i1$1.MatIcon, i3.NgForOf, i3.NgIf],
        styles: [".snack-container[_ngcontent-%COMP%]{height:auto}.snack-container[_ngcontent-%COMP%]   .snack-container-message[_ngcontent-%COMP%]{display:flex;flex-direction:row;width:100%;align-content:flex-start;height:auto}.messagepart[_ngcontent-%COMP%]{font-size:16px}.snack-container[_ngcontent-%COMP%]   .snack-container-message[_ngcontent-%COMP%]   .snack-icon[_ngcontent-%COMP%]{flex-grow:0;size:20px}.snack-container[_ngcontent-%COMP%]   .snack-container-message[_ngcontent-%COMP%]   .snack-msg[_ngcontent-%COMP%]{padding:0 9px;flex-grow:1;max-width:348px;font-size:16px;font-weight:700;margin-top:3px}.snack-container[_ngcontent-%COMP%]   .snack-container-message[_ngcontent-%COMP%]   .snack-close[_ngcontent-%COMP%]{flex-grow:0}.snakbar-warn[_ngcontent-%COMP%]{background-color:#fff;max-width:450px;padding:18px}.snakbar-warn[_ngcontent-%COMP%]   .snack-msg[_ngcontent-%COMP%]{font-weight:700;color:#443f5f}.snakbar-warn[_ngcontent-%COMP%]   .snack-icon[_ngcontent-%COMP%]{color:#fdd835}.snakbar-warn[_ngcontent-%COMP%]   .snack-close[_ngcontent-%COMP%]{color:#443f5f}.snakbar-error[_ngcontent-%COMP%]{background-color:#d0021b;max-width:450px;padding:18px}.snakbar-error[_ngcontent-%COMP%]   .snack-msg[_ngcontent-%COMP%], .snakbar-error[_ngcontent-%COMP%]   .snack-icon[_ngcontent-%COMP%], .snakbar-error[_ngcontent-%COMP%]   .snack-close[_ngcontent-%COMP%]{color:#fff}.snakbar-success[_ngcontent-%COMP%]{background-color:#fff;max-width:450px;padding:18px}.snakbar-success[_ngcontent-%COMP%]   .snack-msg[_ngcontent-%COMP%]{color:#443f5f}.snakbar-success[_ngcontent-%COMP%]   .snack-icon[_ngcontent-%COMP%]{color:#5cc100}.snakbar-success[_ngcontent-%COMP%]   .snack-close[_ngcontent-%COMP%]{color:#443f5f}"]
      });
    }
  }
  return SnackbarComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ConfirmComponent = /*#__PURE__*/(() => {
  class ConfirmComponent {
    constructor(dialogRef) {
      this.dialogRef = dialogRef;
      this.title = "Confirm";
      this.confirmButtonText = "Yes";
      this.cancelButtonText = "Cancel";
      this.isDeleteConfirmDialog = false;
      this.showCancelButton = true;
      this.isShowHTML = false;
      this.dialogRef.addPanelClass(["app-confirm-dialog"]);
    }
    get splittedMessage() {
      if (this.confirmMessage) {
        return this.confirmMessage.split("\n");
      }
    }
    static {
      this.ɵfac = function ConfirmComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ConfirmComponent)(i0.ɵɵdirectiveInject(i1$2.MatDialogRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: ConfirmComponent,
        selectors: [["app-confirm"]],
        decls: 14,
        vars: 8,
        consts: [["mat-dialog-title", ""], ["mat-button", "", 1, "close-icon", 3, "click", "mat-dialog-close"], ["class", "divHtml", "mat-dialog-content", "", 3, "innerHtml", 4, "ngIf"], ["class", "divText", "mat-dialog-content", "", 4, "ngIf"], ["mat-dialog-actions", ""], [3, "click", 4, "ngIf"], ["class", "cancel", "mat-stroked-button", "", "aria-label", "Cancel", 3, "click", 4, "ngIf"], ["mat-flat-button", "", "aria-label", "Confirm", 3, "click", "color"], [1, "cancel"], ["mat-dialog-content", "", 1, "divHtml", 3, "innerHtml"], ["mat-dialog-content", "", 1, "divText"], ["class", "messagepart", 4, "ngFor", "ngForOf"], [1, "messagepart"], [4, "ngIf"], [3, "click"], ["mat-stroked-button", "", "aria-label", "Cancel", 1, "cancel", 3, "click"]],
        template: function ConfirmComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "h1", 0);
            i0.ɵɵtext(1);
            i0.ɵɵelementStart(2, "button", 1);
            i0.ɵɵlistener("click", function ConfirmComponent_Template_button_click_2_listener() {
              return ctx.dialogRef.close(false);
            });
            i0.ɵɵelementStart(3, "mat-icon");
            i0.ɵɵtext(4, "close");
            i0.ɵɵelementEnd()()();
            i0.ɵɵelement(5, "div");
            i0.ɵɵtemplate(6, ConfirmComponent_div_6_Template, 1, 1, "div", 2)(7, ConfirmComponent_div_7_Template, 2, 1, "div", 3);
            i0.ɵɵelementStart(8, "div", 4);
            i0.ɵɵtemplate(9, ConfirmComponent_a_9_Template, 2, 1, "a", 5)(10, ConfirmComponent_button_10_Template, 2, 1, "button", 6);
            i0.ɵɵelementStart(11, "button", 7);
            i0.ɵɵlistener("click", function ConfirmComponent_Template_button_click_11_listener() {
              return ctx.dialogRef.close(true);
            });
            i0.ɵɵelementStart(12, "span", 8);
            i0.ɵɵtext(13);
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate1(" ", ctx.title, " ");
            i0.ɵɵadvance();
            i0.ɵɵproperty("mat-dialog-close", true);
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngIf", ctx.isShowHTML);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", !ctx.isShowHTML);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", !ctx.showCancelButton);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.showCancelButton);
            i0.ɵɵadvance();
            i0.ɵɵproperty("color", ctx.isDeleteConfirmDialog ? "warn" : "primary");
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate1(" ", ctx.confirmButtonText, "");
          }
        },
        dependencies: [i2.MatButton, i1$1.MatIcon, i3.NgForOf, i3.NgIf, i1$2.MatDialogClose, i1$2.MatDialogTitle, i1$2.MatDialogActions, i1$2.MatDialogContent],
        styles: [".app-confirm-dialog{position:relative!important;min-width:30vw!important}.app-confirm-dialog .mat-mdc-button-persistent-ripple:before{background-color:transparent}.app-confirm-dialog .close-icon{float:right;margin-right:2px;padding:0;min-width:20px;background:transparent;color:#fff;height:37px;margin-left:auto}.app-confirm-dialog .close-icon mat-icon{margin:0;font-size:24px;height:24px;width:24px}.app-confirm-dialog .mat-mdc-dialog-content{display:block;margin:0;padding:30px 20px;text-align:center;font-size:16px}.app-confirm-dialog .mat-mdc-dialog-content .messagepart{font-size:16px;color:#443f5f}.app-confirm-dialog .mat-mdc-dialog-title{display:flex;align-items:center;justify-content:flex-start;background:#2d313d 0% 0% no-repeat padding-box;color:#fff;font-size:20px!important;font-weight:600;padding:12px 12px 12px 16px;margin:0;height:65px}.app-confirm-dialog .mat-mdc-button.mat-grey{background:#ccc 0% 0% no-repeat padding-box;box-shadow:0 3px 6px #00000029;border-radius:5px;width:93px}.app-confirm-dialog .mat-mdc-dialog-actions{display:-webkit-box;display:flex;background-color:#f5f5f5;justify-content:flex-end;margin:0;flex-direction:row;padding:20px 30px 20px 20px}.app-confirm-dialog .mat-mdc-dialog-actions button{width:133px}.app-confirm-dialog .mat-mdc-dialog-actions .mat-mdc-outlined-button{background-color:#fff}.app-confirm-dialog .mat-mdc-dialog-actions .cancel{font-size:14px}.app-confirm-dialog .mat-mdc-dialog-actions .mat-mdc-unelevated-button{margin-left:20px}\n"],
        encapsulation: 2
      });
    }
  }
  return ConfirmComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AlertService = /*#__PURE__*/(() => {
  class AlertService {
    constructor(matSnackBar, dialog) {
      this.matSnackBar = matSnackBar;
      this.dialog = dialog;
      this.DEFAULT_DURATION = 5000;
      this.DEFAULT_ACTION_TEXT = "OK";
      this.HORIZONTAL_POSITION = "center";
      this.VERTICAL_POSITION = "top";
    }
    showSnakBar(message, actionText, duration, isShowHTML) {
      if (actionText === null) {
        actionText = this.DEFAULT_ACTION_TEXT;
      }
      if (duration === null) {
        duration = this.DEFAULT_DURATION;
      }
      this.matSnackBar.openFromComponent(SnackbarComponent, {
        duration: duration,
        horizontalPosition: this.HORIZONTAL_POSITION,
        verticalPosition: this.VERTICAL_POSITION,
        // eslint-disable-next-line id-denylist
        data: {
          message: message,
          snackType: "info",
          snackbar: this.matSnackBar,
          isShowHTML: isShowHTML
        },
        panelClass: ["snakbar-info"]
      });
    }
    showSuccessSnakBar(message, actionText, duration, isShowHTML) {
      if (actionText === null) {
        actionText = this.DEFAULT_ACTION_TEXT;
      }
      if (duration === null) {
        duration = this.DEFAULT_DURATION;
      }
      this.matSnackBar.openFromComponent(SnackbarComponent, {
        duration: duration,
        horizontalPosition: this.HORIZONTAL_POSITION,
        verticalPosition: this.VERTICAL_POSITION,
        // eslint-disable-next-line id-denylist
        data: {
          message: message,
          snackType: "success",
          snackbar: this.matSnackBar,
          isShowHTML: isShowHTML
        },
        panelClass: ["snakbar-success"]
      });
    }
    showErrorSnakBar(message, actionText, duration, isShowHTML) {
      if (actionText === null) {
        actionText = this.DEFAULT_ACTION_TEXT;
      }
      if (duration === null) {
        duration = this.DEFAULT_DURATION;
      }
      this.matSnackBar.openFromComponent(SnackbarComponent, {
        duration: duration,
        horizontalPosition: this.HORIZONTAL_POSITION,
        verticalPosition: this.VERTICAL_POSITION,
        // eslint-disable-next-line id-denylist
        data: {
          message: message,
          snackType: "error",
          snackbar: this.matSnackBar,
          isShowHTML: isShowHTML
        },
        panelClass: ["snakbar-error"]
      });
    }
    showWarningSnakBar(message, actionText, duration, isShowHTML) {
      if (actionText === null) {
        actionText = this.DEFAULT_ACTION_TEXT;
      }
      if (duration === null) {
        duration = this.DEFAULT_DURATION;
      }
      this.matSnackBar.openFromComponent(SnackbarComponent, {
        duration: duration,
        horizontalPosition: this.HORIZONTAL_POSITION,
        verticalPosition: this.VERTICAL_POSITION,
        // eslint-disable-next-line id-denylist
        data: {
          message: message,
          snackType: "warn",
          snackbar: this.matSnackBar,
          isShowHTML: isShowHTML
        },
        panelClass: ["snakbar-warn"]
      });
    }
    confirm(message, title, confirmButtonText, cancelButtonText, isDeleteConfirmDialog, panelClass, isShowCancelButton, isShowHTML) {
      this.dialogRef = this.dialog.open(ConfirmComponent, {
        disableClose: true,
        panelClass: panelClass
      });
      this.dialogRef.componentInstance.confirmMessage = message;
      if (title) {
        this.dialogRef.componentInstance.title = title;
      }
      if (confirmButtonText) {
        this.dialogRef.componentInstance.confirmButtonText = confirmButtonText;
      }
      if (cancelButtonText) {
        this.dialogRef.componentInstance.cancelButtonText = cancelButtonText;
      }
      if (isDeleteConfirmDialog) {
        this.dialogRef.componentInstance.isDeleteConfirmDialog = isDeleteConfirmDialog;
      }
      if (!isShowCancelButton) {
        this.dialogRef.componentInstance.showCancelButton = isShowCancelButton;
      }
      if (isShowHTML) {
        this.dialogRef.componentInstance.isShowHTML = isShowHTML;
      }
      return this.dialogRef.afterClosed();
    }
    static {
      this.ɵfac = function AlertService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AlertService)(i0.ɵɵinject(i1$3.MatSnackBar), i0.ɵɵinject(i1$2.MatDialog));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: AlertService,
        factory: AlertService.ɵfac,
        providedIn: "root"
      });
    }
  }
  return AlertService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ClickoutsideDirective = /*#__PURE__*/(() => {
  class ClickoutsideDirective {
    constructor(elementRef) {
      this.elementRef = elementRef;
      this.clickOutside = new EventEmitter();
    }
    onClick(event, targetElement) {
      if (!targetElement) {
        return;
      }
      const clickedInside = this.elementRef.nativeElement.contains(targetElement);
      if (!clickedInside) {
        this.clickOutside.emit(event);
      }
    }
    static {
      this.ɵfac = function ClickoutsideDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ClickoutsideDirective)(i0.ɵɵdirectiveInject(i0.ElementRef));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: ClickoutsideDirective,
        selectors: [["", "clickOutside", ""]],
        hostBindings: function ClickoutsideDirective_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("click", function ClickoutsideDirective_click_HostBindingHandler($event) {
              return ctx.onClick($event, $event.target);
            }, false, i0.ɵɵresolveDocument);
          }
        },
        outputs: {
          clickOutside: "clickOutside"
        }
      });
    }
  }
  return ClickoutsideDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let HeaderComponent = /*#__PURE__*/(() => {
  class HeaderComponent {
    constructor(userService, alertService) {
      this.userService = userService;
      this.alertService = alertService;
      this.isSpaceLoading = true;
      this.isProfileLoading = true;
      this.User = {
        fullName: "",
        email: "",
        nickName: ""
      };
      this.NoSpaceAssignedString = "No Space Assigned";
      this.ShowEditProfileLink = true;
      this.ShowRevokeTokenLink = false;
      this.ShowSpaceList = true;
      this.LanguageId = new EventEmitter();
      this.LogoutEmitter = new EventEmitter();
      this.UserEmitter = new EventEmitter();
      this.SpaceEmitter = new EventEmitter();
      this.RevokeTokenEmitter = new EventEmitter();
      this.isMenuOpened = false;
      this.isMainMenuOpened = false;
      this.isLanguageMenuOpened = false;
      this.showHeaderLogo = false;
      this.headerLogo = "";
      this.displayTheme = "";
      this.userNotFoundErrorMessage = "";
      this.languageSelected = localStorage.getItem("localStoreLang") ? localStorage.getItem("localStoreLang") : "en";
    }
    ngOnInit() {
      this.getUser();
      if (this.ShowSpaceList) {
        this.getUserSpaces();
      }
    }
    getUser() {
      this.unsubscribeAll = new Subject();
      this.userService.getUser(this.ServerUrl).pipe(takeUntil(this.unsubscribeAll)).subscribe({
        next: res => {
          this.User = res;
          this.UserEmitter.emit(res);
          this.isProfileLoading = false;
        },
        error: error => {
          let notFoundStatusCode = 404;
          // If status is 404 that means no user data found. So, We will logout and show error snackbar with provided message.
          if (error.status === notFoundStatusCode) {
            this.alertService.showErrorSnakBar(this.userNotFoundErrorMessage);
            this.logout();
          }
        }
      });
    }
    getUserSpaces() {
      this.isSpaceLoading = true;
      this.unsubscribeAll = new Subject();
      this.userService.getUserSpaces(this.ServerUrl).pipe(takeUntil(this.unsubscribeAll)).subscribe(res => {
        this.Spaces = res;
        let minimumLength = 0;
        let initialIndex = 0;
        if (res.length > minimumLength && !this.SelectedSpace) {
          this.SelectedSpace = res[initialIndex].id;
        }
        this.calculateMaxWidth(this.Spaces);
        this.isSpaceLoading = false;
      });
    }
    changeLang(languageId) {
      this.languageSelected = languageId;
      this.isMainMenuOpened = false;
      this.isLanguageMenuOpened = false;
      this.isMenuOpened = false;
      this.LanguageId.emit(languageId);
    }
    logout() {
      this.LogoutEmitter.emit(true);
    }
    SwitchSpace() {
      this.SpaceEmitter.emit(this.SelectedSpace);
    }
    openMenu() {
      this.isMenuOpened = true;
      this.isMainMenuOpened = this.isMainMenuOpened ? false : true;
      this.isLanguageMenuOpened = false;
    }
    openSubMenu() {
      this.isLanguageMenuOpened = true;
      this.isMainMenuOpened = false;
    }
    hideSubMenu() {
      this.isLanguageMenuOpened = false;
      this.isMainMenuOpened = true;
    }
    revokeRefreshToken() {
      this.RevokeTokenEmitter.emit(true);
    }
    hideBothMenu() {
      if (!this.isMenuOpened) {
        this.isMainMenuOpened = false;
        this.isLanguageMenuOpened = false;
      }
      this.isMenuOpened = false;
    }
    ngOnDestroy() {
      // Unsubscribe from all subscriptions
      this.unsubscribeAll.next(true);
      this.unsubscribeAll.complete();
    }
    openEditProfile() {
      window.open(this.EditProfileUrl, "_blank");
    }
    calculateMaxWidth(spaces) {
      try {
        const canvas = document.createElement("canvas");
        const context = canvas.getContext("2d");
        context.font = "14px Open Sans ,Noto Sans JP";
        // Measure the text
        let maxWidth = 0;
        const totalWidth = 239; // total width of panel is 239
        spaces.forEach(space => {
          const width = space.name ? context.measureText(space.name).width : 0;
          if (width > maxWidth) {
            maxWidth = width;
          }
        });
        maxWidth = maxWidth + 20; // padding is 20
        if (maxWidth > totalWidth) {
          // Apply the width to the mat-option elements
          document.documentElement.style.setProperty("--mat-option-width", `${maxWidth}px`);
        }
      } catch (error) {
        // Optionally, don't need to set the width incase of error
      }
    }
    static {
      this.ɵfac = function HeaderComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HeaderComponent)(i0.ɵɵdirectiveInject(UserService), i0.ɵɵdirectiveInject(AlertService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: HeaderComponent,
        selectors: [["diva-header"]],
        inputs: {
          User: "User",
          EditProfileString: "EditProfileString",
          LanguageSettingString: "LanguageSettingString",
          NoSpaceAssignedString: "NoSpaceAssignedString",
          LogoutString: "LogoutString",
          RevokeTokenString: "RevokeTokenString",
          Languages: "Languages",
          Spaces: "Spaces",
          SelectedSpace: "SelectedSpace",
          ServerUrl: "ServerUrl",
          ShowEditProfileLink: "ShowEditProfileLink",
          ShowRevokeTokenLink: "ShowRevokeTokenLink",
          ShowSpaceList: "ShowSpaceList",
          EditProfileUrl: "EditProfileUrl",
          showHeaderLogo: "showHeaderLogo",
          headerLogo: "headerLogo",
          displayTheme: "displayTheme",
          userNotFoundErrorMessage: "userNotFoundErrorMessage"
        },
        outputs: {
          LanguageId: "LanguageId",
          LogoutEmitter: "LogoutEmitter",
          UserEmitter: "UserEmitter",
          SpaceEmitter: "SpaceEmitter",
          RevokeTokenEmitter: "RevokeTokenEmitter"
        },
        decls: 8,
        vars: 5,
        consts: [[1, "diva-header", 3, "ngClass"], [1, "left-section"], ["class", "diva-header-logo", 3, "src", 4, "ngIf"], [1, "right-section"], ["class", "profileBlock", 4, "ngIf"], [1, "profileBlock"], [4, "ngIf"], [1, "diva-header-logo", 3, "src"], ["panelClass", "spaceSelector", 3, "selectionChange", "valueChange", "disableOptionCentering", "value"], [3, "value", 4, "ngFor", "ngForOf"], [3, "value"], ["mat-button", "", 1, "no-hover-effect", 3, "disableRipple"], [1, "", 3, "click"], [1, "profile-img", 3, "src"], [1, "arrow-wrapper"], ["iconPositionEnd", "", 1, "drop-down-arrow-icon"], [1, "menu-container", 3, "clickOutside"], [1, "menu-outer-panel"], [1, "menu-option"], [1, "user-detail"], [1, "menu-option", 3, "click"], [1, "material-icons"], [1, "material-icons", "checkIconLang"], ["class", "menu-option", "mat-menu-item", "", 3, "click", 4, "ngIf"], ["mat-menu-item", "", 1, "menu-option", 3, "click"], [1, "sub-menu"], ["class", "menu-option language", "mat-menu-item", "", 3, "click", 4, "ngFor", "ngForOf"], ["mat-menu-item", "", 1, "menu-option", "language", 3, "click"], ["class", "material-icons checkIcon", 4, "ngIf"], [1, "material-icons", "checkIcon"]],
        template: function HeaderComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
            i0.ɵɵtemplate(2, HeaderComponent_img_2_Template, 1, 1, "img", 2);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(3, "div", 3);
            i0.ɵɵtemplate(4, HeaderComponent_div_4_Template, 4, 3, "div", 4);
            i0.ɵɵelementStart(5, "div", 5);
            i0.ɵɵtemplate(6, HeaderComponent_mat_spinner_6_Template, 1, 0, "mat-spinner", 6)(7, HeaderComponent_div_7_Template, 38, 14, "div", 6);
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngClass", ctx.displayTheme);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.showHeaderLogo);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.ShowSpaceList);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.isProfileLoading);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", !ctx.isProfileLoading);
          }
        },
        dependencies: [i2.MatButton, i4.MatFormField, i4.MatLabel, i5.MatMenuItem, i6.MatSelect, i7.MatOption, i1$1.MatIcon, i3.NgClass, i3.NgForOf, i3.NgIf, i10.MatProgressSpinner, ClickoutsideDirective],
        styles: [".diva-header{display:flex;align-items:center;justify-content:space-between;height:60px;box-shadow:0 1px 2px #0000001a;background-color:#fff;z-index:2;position:relative}  .diva-header .left-section .diva-header-logo{margin-left:20px}  .diva-header .right-section{display:flex;align-items:center}  .diva-header .profileBlock{min-width:150px}  .diva-header .mat-mdc-form-field{height:19px;padding:0;width:auto;margin:0 15px 0 0!important}  .diva-header .mat-mdc-form-field .mat-mdc-text-field-wrapper{padding:0;background-color:transparent}  .diva-header .mat-mdc-form-field .mat-mdc-text-field-wrapper .mat-mdc-form-field-focus-overlay{background-color:transparent}  .diva-header .mat-mdc-form-field .mat-mdc-form-field-subscript-wrapper{display:none}  .diva-header .mat-mdc-form-field .mdc-text-field--filled:not(.mdc-text-field--disabled){background-color:transparent}  .diva-header .mat-mdc-form-field .mdc-line-ripple{display:none}  .diva-header .mat-mdc-form-field .mat-mdc-select-trigger{height:17px}  .diva-header .mat-mdc-form-field .mat-mdc-select-arrow-wrapper{transform:none;width:18px}  .diva-header .mat-mdc-form-field .mat-mdc-select-arrow-wrapper .mat-mdc-select-arrow{color:#205a85;width:18px}  .diva-header .mat-mdc-form-field .mat-mdc-select-arrow-wrapper .mat-mdc-form-field.mat-focused.mat-primary .mat-mdc-select-arrow{color:#205a85}  .diva-header .mat-mdc-button{height:60px;margin-right:20px}  .diva-header .mat-mdc-button .mat-mdc-button-persistent-ripple:before{background-color:transparent}  .diva-header .mat-mdc-button .mdc-button__label{white-space:nowrap}  .diva-header .mat-mdc-button .mdc-button__label .arrow-wrapper{width:18px;justify-content:center;flex-shrink:0;margin-left:auto}  .diva-header .mat-mdc-button .mdc-button__label .arrow-wrapper .drop-down-arrow-icon{position:absolute;color:#205a85}  .diva-header button{border-left:1px solid #ccc!important;height:60px;border-radius:0!important;width:145px;padding:0 0 0 15px!important;box-sizing:content-box;display:inline-block}  .diva-header button img{max-height:35px;width:35px;height:35px;border-radius:50%;margin-right:10px}  .diva-header button span span{overflow:hidden;padding-right:16px;text-overflow:ellipsis;line-height:36px;width:100%}  .diva-header button .mdc-button__ripple:before{background-color:transparent}  .diva-header button span div{display:flex;align-items:center}  .diva-header mat-spinner{width:20px!important;height:20px!important;margin:0 auto}  .diva-header mat-spinner svg{width:20px!important;height:20px!important}  .diva-header .checkIcon{padding-left:18px!important}  .diva-header .checkIconLang{padding-left:30px!important}  .diva-header .mat-mdc-form-field .mat-mdc-text-field-wrapper .mat-mdc-form-field-infix{padding:0}  .diva-header .mat-mdc-form-field .mat-mdc-text-field-wrapper .mat-mdc-form-field-infix .mat-mdc-select-value{text-align:right;padding-right:16px}  .header_only{background-color:#141720!important;z-index:2!important;height:60px!important}  .header_only nav{box-shadow:0 3px 6px #00000029!important;height:60px!important}  .header_only .diva-header .mat-mdc-form-field{background:#edf1f7;background:transparent}  .header_only .diva-header .mat-mdc-form-field .mat-mdc-text-field-wrapper .mat-mdc-form-field-infix .mat-mdc-select-value{color:#fff;text-align:right;padding-right:15px}  .header_only .diva-header .mat-mdc-form-field .mat-mdc-select-arrow{color:#141720;border:none;position:relative;top:-2px}  .header_only .diva-header .mat-mdc-form-field .mat-mdc-select-arrow:after,   .header_only .diva-header .mat-mdc-form-field .mat-mdc-select-arrow:before{top:100%;left:50%;border:solid transparent;content:\" \";height:0;width:0;position:absolute;pointer-events:none;z-index:9}  .header_only .diva-header .mat-mdc-form-field .mat-mdc-select-arrow:after{border-top-color:#fff;border-width:5px;margin-left:-5px}  .header_only .diva-header .mat-mdc-form-field .mat-mdc-select-arrow:before{border-top-color:#141720;border-width:7px;margin-left:-7px}  .header_only .diva-header button{color:#fff;border:none}  .header_only .diva-header button span span{padding-right:20px}  .header_only .diva-header button span:before{top:47%;right:0;border:solid transparent;content:\" \";height:0;width:0;position:absolute;pointer-events:none;z-index:9;border-top-color:#141720;border-width:7px;margin-left:-7px}  .header_only .diva-header button span:after{top:47%;right:2px;border:solid transparent;content:\" \";height:0;width:0;position:absolute;pointer-events:none;z-index:9;border-top-color:#fff;border-width:5px;margin-left:-5px}  .diva-header.dark{background-color:#141720}  .diva-header.dark .mat-mdc-form-field .mat-mdc-select-arrow{color:#fff}  .diva-header.dark .mat-mdc-form-field .mat-mdc-text-field-wrapper .mat-mdc-form-field-infix .mat-mdc-select-value{color:#fff;font-size:15px}  .diva-header.dark .mat-mdc-button .mdc-button__label .arrow-wrapper .drop-down-arrow-icon{color:#fff}  .diva-header.dark button{color:#fff}  .diva-header.dark button span span{padding-right:20px}  .spaceSelector.mdc-menu-surface.mat-mdc-select-panel{padding:0;margin-top:17.5px;position:absolute;right:0;width:239px}  .spaceSelector{box-shadow:0 0 4px #00000029!important;border-radius:6px!important}  .spaceSelector .mat-pseudo-checkbox{display:none}  .spaceSelector .mat-mdc-option{padding:0 10px;min-height:40px;width:var(--mat-option-width);box-sizing:border-box}  .spaceSelector .mat-mdc-option.mdc-list-item--selected:not(.mat-mdc-option-multiple):not(.mdc-list-item--disabled){background:#f5f5f5}  .spaceSelector .mat-mdc-option.mdc-list-item--selected:not(.mat-mdc-option-multiple):not(.mdc-list-item--disabled) .mdc-list-item__primary-text{color:#000000de}  .spaceSelector .mat-mdc-option:hover:not(.mdc-list-item--selected){background:#337ab7}  .spaceSelector .mat-mdc-option:hover:not(.mdc-list-item--selected) .mdc-list-item__primary-text{color:#fff}.menu-container[_ngcontent-%COMP%]{position:relative}.menu-container[_ngcontent-%COMP%]   .menu-outer-panel[_ngcontent-%COMP%]{right:5px;top:-5px;width:239px;height:auto;position:absolute;box-shadow:0 0 20px #00000029;overflow:hidden;border-radius:4px;background:#fff;padding:0 0 7px}.menu-container[_ngcontent-%COMP%]   .menu-option[_ngcontent-%COMP%]{margin:3px 0;cursor:pointer;white-space:nowrap;width:100%;border:none!important;overflow:hidden;text-overflow:ellipsis;display:block;height:38px;padding:0 15px;text-align:left;text-decoration:none;display:flex!important;flex-direction:row;align-items:center;color:#000;font-size:14px;background-color:transparent}.menu-container[_ngcontent-%COMP%]   .menu-option.mat-mdc-menu-item.language[_ngcontent-%COMP%]{flex-direction:row-reverse;justify-content:flex-end}.menu-container[_ngcontent-%COMP%]   .menu-option[_ngcontent-%COMP%]:focus{outline:none}.menu-container[_ngcontent-%COMP%]   .menu-option[_ngcontent-%COMP%]:first-child{border-bottom:1px solid #ccc!important;padding-bottom:2px;height:65px;cursor:default}.menu-container[_ngcontent-%COMP%]   .menu-option[_ngcontent-%COMP%]:first-child:hover{background:#fff}.menu-container[_ngcontent-%COMP%]   .sub-menu[_ngcontent-%COMP%]   .menu-option[_ngcontent-%COMP%]:first-child{cursor:pointer}.menu-container[_ngcontent-%COMP%]   .sub-menu[_ngcontent-%COMP%]   .menu-option[_ngcontent-%COMP%]:first-child:hover{background:#0000000a}.menu-container[_ngcontent-%COMP%]   .menu-option[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{max-height:45px;width:45px;height:45px;border-radius:50%;margin-right:15px}.menu-container[_ngcontent-%COMP%]   .menu-option[_ngcontent-%COMP%]   .user-detail[_ngcontent-%COMP%]{display:flex;flex-direction:column;line-height:1.2;word-break:break-word;white-space:normal}.menu-container[_ngcontent-%COMP%]   .menu-option[_ngcontent-%COMP%]   .user-detail[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]:first-child{font-weight:700}.menu-container[_ngcontent-%COMP%]   .menu-option[_ngcontent-%COMP%]:hover{background:#0000000a}.menu-container[_ngcontent-%COMP%]   .menu-option[_ngcontent-%COMP%]   .mat-icon[_ngcontent-%COMP%]{flex:0;margin-right:5px;color:#2d313d}.menu-container[_ngcontent-%COMP%]   .sub-menu[_ngcontent-%COMP%]{right:0;top:-10px;width:239px;z-index:9;position:absolute;box-shadow:0 2px 4px -1px #0003,0 4px 5px #00000024,0 1px 10px #0000001f;overflow:hidden;border-radius:4px;background:#fff;padding:0 0 7px}"],
        data: {
          animation: [trigger("menuAnimation", [state("close", style({
            opacity: 0,
            visibility: "hidden",
            width: "239px"
          })), state("other", style({
            opacity: 1,
            visibility: "hidden",
            width: "0px"
          })), state("open", style({
            opacity: 1,
            visibility: "visible",
            width: "239px"
          })), transition("close => open", animate("300ms ease-in-out", style({
            opacity: 1,
            visibility: "visible"
          }))), transition("open => close", animate("300ms ease-in-out", style({
            opacity: 0,
            visibility: "hidden"
          }))), transition("open => other", animate("300ms ease-in-out", style({
            width: "0px"
          }))), transition("other => open", animate("300ms ease-in-out", style({
            width: "239px",
            visibility: "visible"
          })))])]
        }
      });
    }
  }
  return HeaderComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const easeInOut = [trigger("easeInOut", [state("void", style({
  height: "0px"
})), state("*", style({
  height: "*"
})), transition("void => *", animate("0.6s ease-out")), transition("* => void", animate("0.6s ease-in"))])];
let BannerComponent = /*#__PURE__*/(() => {
  class BannerComponent {
    constructor() {
      this.isOpen = false;
      this.OnActionClick = new EventEmitter();
    }
    ngOnInit() {}
    /**
     * Action button click event handler.
     */
    actionClick() {
      this.isOpen = false;
      this.OnActionClick.emit();
    }
    /**
     * Parse the data in observable.
     * @param value Value
     */
    parseData(value) {
      return typeof value === "string" ? of(value) : value;
    }
    static {
      this.ɵfac = function BannerComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || BannerComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: BannerComponent,
        selectors: [["diva-banner"]],
        hostVars: 1,
        hostBindings: function BannerComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵsyntheticHostProperty("@easeInOut", undefined);
          }
        },
        inputs: {
          bannerData: "bannerData",
          isOpen: "isOpen"
        },
        outputs: {
          OnActionClick: "OnActionClick"
        },
        decls: 1,
        vars: 1,
        consts: [["class", "diva-banner", 3, "error-banner", "background", 4, "ngIf"], [1, "diva-banner"], [1, "diva-banner-content"], [1, "diva-banner-icon-text"], [1, "diva-banner-icon", 3, "ngSwitch"], ["class", "info", 4, "ngSwitchCase"], ["class", "warning", "fontSet", "material-icons-round", 4, "ngSwitchCase"], ["class", "error", 4, "ngSwitchCase"], [1, "diva-banner-text"], [1, "diva-banner-text-first-line"], [1, "diva-banner-text-second-line"], [1, "diva-banner-action"], ["mat-button", "", "color", "primary", "aria-label", "close banner", 3, "click"], [1, "info"], ["fontSet", "material-icons-round", 1, "warning"], [1, "error"]],
        template: function BannerComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, BannerComponent_div_0_Template, 19, 17, "div", 0);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.isOpen);
          }
        },
        dependencies: [i2.MatButton, i1$1.MatIcon, i3.NgIf, i3.NgSwitch, i3.NgSwitchCase, i3.AsyncPipe],
        styles: ["[_nghost-%COMP%]{background-color:#e2eff9;overflow:hidden;display:block}.diva-banner[_ngcontent-%COMP%]{background-color:#e2eff9;overflow:hidden;display:flex;flex-direction:column}.diva-banner[_ngcontent-%COMP%]   .diva-banner-content[_ngcontent-%COMP%]{display:flex;flex-direction:row;flex:1;align-items:center;justify-content:center;padding:15px 25px;flex-flow:wrap;max-width:750px;align-self:center}.diva-banner[_ngcontent-%COMP%]   .diva-banner-content[_ngcontent-%COMP%]   .diva-banner-icon-text[_ngcontent-%COMP%]{display:flex;margin-right:40px;max-width:526px}.diva-banner[_ngcontent-%COMP%]   .diva-banner-content[_ngcontent-%COMP%]   .diva-banner-icon-text[_ngcontent-%COMP%]   .diva-banner-icon[_ngcontent-%COMP%]{height:44px;display:flex;align-items:center}.diva-banner[_ngcontent-%COMP%]   .diva-banner-content[_ngcontent-%COMP%]   .diva-banner-icon-text[_ngcontent-%COMP%]   .diva-banner-icon[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%]{height:40px;width:40px;font-size:40px}.diva-banner[_ngcontent-%COMP%]   .diva-banner-content[_ngcontent-%COMP%]   .diva-banner-icon-text[_ngcontent-%COMP%]   .diva-banner-icon[_ngcontent-%COMP%]   .info[_ngcontent-%COMP%]{color:#379be5}.diva-banner[_ngcontent-%COMP%]   .diva-banner-content[_ngcontent-%COMP%]   .diva-banner-icon-text[_ngcontent-%COMP%]   .diva-banner-icon[_ngcontent-%COMP%]   .warning[_ngcontent-%COMP%]{color:#fdd835}.diva-banner[_ngcontent-%COMP%]   .diva-banner-content[_ngcontent-%COMP%]   .diva-banner-icon-text[_ngcontent-%COMP%]   .diva-banner-icon[_ngcontent-%COMP%]   .error[_ngcontent-%COMP%]{color:#e53737}.diva-banner[_ngcontent-%COMP%]   .diva-banner-content[_ngcontent-%COMP%]   .diva-banner-icon-text[_ngcontent-%COMP%]   .diva-banner-text[_ngcontent-%COMP%]{margin-left:20px;height:auto;display:flex;flex-direction:column;align-items:flex-start;line-height:22px;font-size:16px;font-weight:600;color:#443f5f}@media (max-width: 750px){.diva-banner[_ngcontent-%COMP%]   .diva-banner-content[_ngcontent-%COMP%]   .diva-banner-icon-text[_ngcontent-%COMP%]{width:100%}}.diva-banner[_ngcontent-%COMP%]   .diva-banner-content[_ngcontent-%COMP%]   .diva-banner-action[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{height:40px;min-width:94px;color:#fff;font-weight:700;background-color:#379be5;font-size:14px}@media (max-width: 750px){.diva-banner[_ngcontent-%COMP%]   .diva-banner-content[_ngcontent-%COMP%]   .diva-banner-action[_ngcontent-%COMP%]{display:flex;flex:1;place-content:flex-end;margin-top:12px}}.error-banner[_ngcontent-%COMP%]{background-color:#fff}"],
        data: {
          animation: [easeInOut]
        }
      });
    }
  }
  return BannerComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DivaLibModule = /*#__PURE__*/(() => {
  class DivaLibModule {
    static {
      this.ɵfac = function DivaLibModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DivaLibModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: DivaLibModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [MatButtonModule, MatInputModule, MatFormFieldModule, MatMenuModule, MatSelectModule, MatIconModule, CommonModule, MatProgressSpinnerModule, MatDialogModule, MatButtonModule, MatInputModule, MatFormFieldModule, MatMenuModule, MatSelectModule, MatIconModule, MatProgressSpinnerModule, MatDialogModule]
      });
    }
  }
  return DivaLibModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SharedService = /*#__PURE__*/(() => {
  class SharedService {
    constructor() {}
    /**
     * This method is used for checking if the string contains
     * html tags or not like<a>
    */
    checkHtmlTags(inputString) {
      let hasTag;
      hasTag = inputString.match(/(<([^>]+)>)/ig);
      if (hasTag) {
        return true;
      }
      return false;
    }
    escapeHtml(inputString) {
      return inputString.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
    }
    static {
      this.ɵfac = function SharedService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SharedService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: SharedService,
        factory: SharedService.ɵfac,
        providedIn: "root"
      });
    }
  }
  return SharedService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CustomHtmlValidator = /*#__PURE__*/(() => {
  class CustomHtmlValidator {
    constructor(sharedService) {
      this.sharedService = sharedService;
    }
    /**
     * This is custom validator it will return null if
     * the string does not contains html tags and it will return
     * object if string contains Html tags like <a>
     */
    htmlValidator() {
      return control => {
        let hasTag;
        if (control.value !== null && control.value !== undefined) {
          hasTag = this.sharedService.checkHtmlTags(control.value);
          if (hasTag) {
            return [{
              ContainHtml: true
            }];
          }
        }
        return null;
      };
    }
    static {
      this.ɵfac = function CustomHtmlValidator_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CustomHtmlValidator)(i0.ɵɵinject(SharedService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: CustomHtmlValidator,
        factory: CustomHtmlValidator.ɵfac
      });
    }
  }
  return CustomHtmlValidator;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * This is used to handle banner activities.
 */
let BannerService = /*#__PURE__*/(() => {
  class BannerService {
    constructor(appRef, injector) {
      this.appRef = appRef;
      this.injector = injector;
      // List of banner component.
      this.components = [];
    }
    /**
     * Create Banner Component and add in provided element.
     * If element is not provided then it add the component in body.
     * If you are passing id then add prefix # with id. Like "#custom-id". Pass class as element with Dot like  ".class-name"
     * @param component Type or component ref of Banner Component.
     * @param element [Optional] query selector or element to add created component. Example: '#banner-container' to find element by id
     */
    create(component, element) {
      // Get component ref.
      const componentRef = component instanceof ComponentRef ? component : createComponent(BannerComponent, {
        environmentInjector: this.appRef.injector
      });
      // Attach view.
      this.appRef.attachView(componentRef.hostView);
      // If element value is string the get html element.
      if (typeof element === "string") {
        element = document.querySelector(element);
      }
      // If no element find then add component in body.
      if (!element) {
        element = document.body;
      }
      // add component in element
      let initialIndex = 0;
      element.appendChild(componentRef.hostView.rootNodes[initialIndex]);
      // We are maintaining list of created component. We can use this to get reference to dispose.
      this.components.push(componentRef);
      return componentRef;
    }
    /**
     * This method will detach and destroy provided component.
     * @param componentRef Banner Component ref to detach and destroy.
     */
    destroy(componentRef) {
      this.appRef.detachView(componentRef.hostView);
      componentRef.destroy();
    }
    /**
     * Property to get list of attached Banner Components.
     */
    get GetComponents() {
      return this.components;
    }
    /**
     * Close the provided Banner Component.
     * @param componentRef Banner Component ref.
     */
    close(componentRef) {
      let findComponentRef = this.components.find(component => component === componentRef);
      if (findComponentRef) {
        this.destroy(findComponentRef);
        return true;
      }
      return false;
    }
    /**
     * Close all the Banner Component.
     */
    closeAll() {
      let minimumLength = 0;
      while (this.components.length > minimumLength) {
        this.destroy(this.components.pop());
      }
    }
    /**
     * Create Banner with provided data and show in provided element.
     * If element is not provided then it add the component in body.
     * If you are passing id then add prefix # with id. Like "#custom-id". Pass class as element with Dot like  ".class-name"
     * Note: Close this Banner when no longer required from calling component.
     * @param banner Banner Component data to create Banner.
     * @param element [Optional] Element or query selector to add Banner.
     */
    open(banner, element) {
      const component = this.create(BannerComponent, element);
      component.instance.bannerData = banner;
      component.instance.isOpen = true;
      return component;
    }
    static {
      this.ɵfac = function BannerService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || BannerService)(i0.ɵɵinject(i0.ApplicationRef), i0.ɵɵinject(i0.Injector));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: BannerService,
        factory: BannerService.ɵfac,
        providedIn: "root"
      });
    }
  }
  return BannerService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var BannerType = /*#__PURE__*/function (BannerType) {
  BannerType["Information"] = "Information";
  BannerType["Warning"] = "Warning";
  BannerType["Error"] = "Error";
  return BannerType;
}(BannerType || {});
/*
 * Public API Surface of @diva/diva-lib
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AlertService, BannerComponent, BannerService, BannerType, ClickoutsideDirective, ConfirmComponent, CustomHtmlValidator, DivaLibModule, HeaderComponent, SharedService, SnackbarComponent, UserService };
